import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

export const routing = defineRouting({
  locales: ['en', 'pl'],
  defaultLocale: 'pl',
  localePrefix: 'as-needed',
  localeDetection: false,
  pathnames: {
    '/': '/',
    '/login': {
      en: '/login',
      pl: '/logowanie'
    },
    '/register': {
      en: '/register',
      pl: '/rejestracja'
    },
    '/forgot-password': {
      en: '/forgot-password',
      pl: '/zapomnialem-hasla'
    },
    '/reset-password': {
      en: '/reset-password',
      pl: '/resetuj-haslo'
    },
    '/settings': {
      en: '/settings',
      pl: '/ustawienia'
    },
    '/dashboard': {
      en: '/dashboard',
      pl: '/panel'
    },
    '/dashboard/cruises/published': {
      en: '/dashboard/cruises/published',
      pl: '/panel/rejsy/opublikowane'
    },
    '/dashboard/cruises/ready-to-publish': {
      en: '/dashboard/cruises/ready-to-publish',
      pl: '/panel/rejsy/gotowe-do-publikacji'
    },
    '/dashboard/cruises/drafts': {
      en: '/dashboard/cruises/drafts',
      pl: '/panel/rejsy/szkice'
    },
    '/dashboard/cruises/archived': {
      en: '/dashboard/cruises/archived',
      pl: '/panel/rejsy/zarchiwizowane'
    },
    '/cruises': {
      en: '/cruises',
      pl: '/rejsy'
    },
    '/cruises/create': {
      en: '/cruises/publish',
      pl: '/rejsy/publikuj'
    },
    '/cruises/[id]': {
      en: '/cruises/[id]',
      pl: '/rejsy/[id]'
    },
    '/support': {
      en: '/support',
      pl: '/wsparcie'
    },
    '/contact': {
      en: '/contact',
      pl: '/kontakt'
    },
    '/faq': {
      en: '/faq',
      pl: '/faq'
    },
    '/privacy': {
      en: '/privacy-policy',
      pl: '/polityka-prywatnosci'
    },
    '/terms': {
      en: '/terms-of-service',
      pl: '/regulamin'
    },
    '/admin/users': {
      en: '/admin/users',
      pl: '/admin/uzytkownicy'
    },
    '/admin/users/[id]': {
      en: '/admin/users/[id]',
      pl: '/admin/uzytkownicy/[id]'
    },
    '/admin/users/[id]/plans': {
      en: '/admin/users/[id]/plans',
      pl: '/admin/uzytkownicy/[id]/plany'
    },
    '/admin/approvals': {
      en: '/admin/approvals',
      pl: '/admin/zatwierdzenia'
    },
    '/admin/queues': {
      en: '/admin/queues',
      pl: '/admin/kolejki'
    },
    '/admin/cruises/pending': {
      en: '/admin/cruises/pending',
      pl: '/admin/rejsy/oczekujace'
    },
    '/admin/organizations/pending': {
      en: '/admin/organizations/pending',
      pl: '/admin/organizacje/oczekujace'
    },
    '/admin/faq': {
      en: '/admin/faq',
      pl: '/admin/faq'
    },
    '/admin/photos': {
      en: '/admin/photos',
      pl: '/admin/zdjecia'
    },
    '/admin/plans': {
      en: '/admin/plans',
      pl: '/admin/plany'
    },
    '/admin/regions/backfill': {
      en: '/admin/regions/backfill',
      pl: '/admin/miejsca/uzupelnij'
    },
    '/admin/regions/regenerate': {
      en: '/admin/regions/regenerate',
      pl: '/admin/miejsca/regeneruj'
    },
    '/cookies': {
      en: '/cookie-policy',
      pl: '/polityka-cookies'
    },
    '/notifications': {
      en: '/notifications',
      pl: '/powiadomienia'
    },
    '/organizations/create': {
      en: '/organizations/create',
      pl: '/organizacje/stworz'
    },
    '/organizations/[id]/edit': {
      en: '/organizations/[id]/edit',
      pl: '/organizacje/[id]/edytuj'
    },
    '/organization/[id]/dashboard': {
      en: '/organization/[id]/dashboard',
      pl: '/organizacja/[id]/panel'
    },
    '/organizations/invitations': {
      en: '/organizations/invitations',
      pl: '/organizacje/zaproszenia'
    },
    '/organizations/invitations/[id]/accept': {
      en: '/organizations/invitations/[id]/accept',
      pl: '/organizacje/zaproszenia/[id]/akceptuj'
    },
    '/organizations': {
      en: '/organizations',
      pl: '/organizacje'
    },
    '/pricing': {
      en: '/pricing',
      pl: '/cennik'
    },
    '/regions/[slug]': {
      en: '/regions/[slug]',
      pl: '/miejsca/[slug]'
    },
    '/[slug]': {
      en: '/[slug]',
      pl: '/[slug]'
    },
    '/welcome-onboard': {
      en: '/welcome-onboard',
      pl: '/witaj-na-pokladzie'
    },
  }
});

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
